export enum DefaultOriginIdEnum {
  SEARCH_BOX = 'search_box',

  DEFAULT = 'default',

  DEFAULT_SEARCH = 'natural', // Kroger
}

export enum PredictiveOriginIdEnum {
  POPULAR_SEARCH = 'popular_search',
  HISTORY_QUERY = 'history_query',

  EMPATHIZE_TRENDING = 'empathize_trending',
  HISTORY = 'history',

  URL = 'url',

  TRENDING = 'trending', // Kroger
  HISTORICAL = 'historical', // Kroger
}

export enum RefinementOriginIdEnum {
  QUERY_SUGGESTION = 'query_suggestion',
  QUERY_SUGGESTION_WITH_FACET = 'query_suggestion_with_facet',
  IDENTIFIER_SUGGESTION = 'identifier_suggestion',
  PARTIAL_RESULT = 'partial_result',
  SPELLCHECK = 'spellcheck',
  RELATED_TAG = 'related_tag',
  NEXT_QUERY = 'next_query',

  SEMANTICS = 'semantics',

  EMPATHIZE = 'empathize_term',
  EMPATHIZE_CATEGORY = 'empathize_category',
  EMPATHIZE_NEXT_QUERIES = 'empathize_next_queries',

  AUTOCOMPLETE = 'autocomplete', // Kroger
  PARTIALS = 'partials', // Kroger
  RELATED_TAGS = 'related tag', // Kroger
  WHATS_NEXT = 'whats next', // Kroger
  WHATS_NEXT_CAROUSEL = 'whats next carousel', // Kroger

  RELATED = 'related', // Zara
}

export const OriginIdEnum = {
  ...DefaultOriginIdEnum,
  ...PredictiveOriginIdEnum,
  ...RefinementOriginIdEnum,
}
export type OriginIdEnum = DefaultOriginIdEnum | PredictiveOriginIdEnum | RefinementOriginIdEnum
